module.exports = __webpack_public_path__ + "static/media/previous-arrow-small.d9c49451.svg";